// Deep-merge utilities — used to combine server overrides with default content.

export function deepMerge(target, source) {
  if (source == null) return target;
  if (target == null) return source;
  // Arrays: source replaces target entirely (don't merge lists item-by-item)
  if (Array.isArray(source)) return source;
  if (typeof source !== "object") return source;
  const out = { ...(target || {}) };
  for (const key of Object.keys(source)) {
    const sv = source[key];
    const tv = out[key];
    if (sv && typeof sv === "object" && !Array.isArray(sv) && tv && typeof tv === "object" && !Array.isArray(tv)) {
      out[key] = deepMerge(tv, sv);
    } else {
      out[key] = sv;
    }
  }
  return out;
}

export function getByPath(obj, path) {
  if (!obj) return undefined;
  const parts = String(path).split(".");
  let cur = obj;
  for (const p of parts) {
    if (cur == null || typeof cur !== "object") return undefined;
    cur = cur[p];
  }
  return cur;
}

export function setByPath(obj, path, value) {
  const parts = String(path).split(".");
  const out = obj ? { ...obj } : {};
  let cur = out;
  for (let i = 0; i < parts.length - 1; i++) {
    const k = parts[i];
    const next = cur[k];
    cur[k] = next && typeof next === "object" && !Array.isArray(next) ? { ...next } : {};
    cur = cur[k];
  }
  cur[parts[parts.length - 1]] = value;
  return out;
}

export function deletePath(obj, path) {
  const parts = String(path).split(".");
  const out = obj ? JSON.parse(JSON.stringify(obj)) : {};
  let cur = out;
  for (let i = 0; i < parts.length - 1; i++) {
    if (!cur[parts[i]] || typeof cur[parts[i]] !== "object") return out;
    cur = cur[parts[i]];
  }
  delete cur[parts[parts.length - 1]];
  return out;
}
